import { pathes } from './pathes'
import { lazy } from 'react'
import MyGroups from '@/screens/MyGroups'
import Group from '@/screens/Group'
import ChooseGroup from '@/screens/ChooseGroup'
const OnBoarding = lazy(() => import('@/screens/OnBoarding'))
const Layout = lazy(() => import('@/shahrzad-assets/shared_components/Layout'))
const TransactionReceipt = lazy(() => import('@/screens/TransactionReceipt'))

const Cinema = lazy(() => import('@/screens/Cinema'))

const Signup = lazy(() => import('@/screens/Signup'))
const SignupForm = lazy(() => import('@/screens/SignupForm'))
const ChangeNumber = lazy(() => import('@/screens/ChangeNumber'))
const ChangeNumberOtp = lazy(() => import('@/screens/ChangeNumberOtp'))
const UserLevels = lazy(() => import('@/screens/UserLevels'))

const LoginPhoneNumber = lazy(() => import('@/screens/LoginPhoneNumber'))
const LoginUsername = lazy(() => import('@/screens/LoginUsername'))
const LoginOtp = lazy(() => import('@/shahrzad-assets/shared-screens/LoginOtp'))

const Payment = lazy(() => import('@/screens/Payment'))
const PaymentCode = lazy(() => import('@/components/gift/PaymentCode'))
const SuccessPayment = lazy(() => import('@/screens/SuccessPayment'))
const QrPayment = lazy(() => import('@/screens/QrPayment'))
const ShopPayment = lazy(() => import('@/screens/ShopPayment'))
const CashWithDrawal = lazy(() => import('@/screens/CashWithDrawal'))

const Home = lazy(() => import('@/screens/Home'))
const Profile = lazy(() => import('@/screens/Profile'))
const AboutShahrzad = lazy(() => import('@/screens/AboutShahrzad'))
const Faq = lazy(() => import('@/screens/Faq'))
const Setting = lazy(() => import('@/screens/Setting'))
const ChangeBackground = lazy(() => import('@/screens/ChangeBackground'))
const MyGifts = lazy(() => import('@/screens/MyGifts'))
const Privacy = lazy(() => import('@/screens/Privacy'))
const Wallet = lazy(() => import('@/screens/Wallet'))
const WalletBarcode = lazy(() => import('@/screens/WalletBarcode'))

const SupportTicket = lazy(() => import('@/screens/ticketing/SupportTicket'))
const UserMesage = lazy(() => import('@/screens/ticketing/UserMessage'))
const CentersList = lazy(() => import('@/screens/wallet-payment/CentersList'))
const ReceiveMoney = lazy(() => import('@/screens/wallet-payment/RecieveMoney'))

import InviteFriends from '@/screens/InviteFriends'
import Vcard from '@/screens/Vcard'
import CreateGroup from '@/screens/CreateGroup'
import SignupLegalUser from '@/screens/SignupLegalUser'
const ShahrzadCode = lazy(() => import('@/screens/ShahrzadCode'))
const Festival = lazy(() => import('@/screens/Festival'))

interface IRoutes {
  path: string
  component: any
  layout: any
  exact: boolean
  navButton?: boolean
}

export const AuthRoutes: Partial<IRoutes>[] = [
  {
    path: pathes.DEFAULT,
    component: OnBoarding,
    exact: true,
  },
  {
    path: pathes.ON_BOARDING,
    component: OnBoarding,
    exact: true,
  },
  {
    path: pathes.LOGIN_PHONE_NUMBER,
    component: LoginPhoneNumber,
    exact: true,
  },
  {
    path: pathes.LOGIN_OTP,
    component: LoginOtp,
    exact: true,
  },
  {
    path: pathes.LOGIN_USERNAME,
    component: LoginUsername,
    exact: true,
  },
  {
    path: pathes.SIGNUP,
    component: Signup,
    exact: true,
  },
  {
    path: pathes.SIGNUP_LEGAL_USER,
    component: SignupLegalUser,
    exact: true,
  },
  // {
  //   path: pathes.SIGNUP_OTP,
  //   component: SignupOtp,
  //   exact: true,
  // },
  {
    path: pathes.SIGNUP_FORM,
    component: SignupForm,
    exact: true,
  },
  {
    path: pathes.CHANGE_NUMBER,
    component: ChangeNumber,
    exact: true,
  },
  {
    path: pathes.CHANGE_NUMBER_OTP,
    component: ChangeNumberOtp,
    exact: true,
  },
  {
    path: pathes.PRIVACY,
    component: Privacy,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.CINEMA,
    component: Cinema,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.FAQ,
    component: Faq,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.ABOUT_SHAHRZAD,
    component: AboutShahrzad,
    exact: true,
    layout: Layout,
  },
]

export const MainRoutes: Partial<IRoutes>[] = [
  {
    path: pathes.DEFAULT,
    component: Home,
    exact: true,
  },

  {
    path: pathes.ON_BOARDING,
    component: OnBoarding,
    exact: true,
  },
  {
    path: pathes.LOGIN_PHONE_NUMBER,
    component: LoginPhoneNumber,
    exact: true,
  },
  {
    path: pathes.LOGIN_OTP,
    component: LoginOtp,
    exact: true,
  },
  {
    path: pathes.LOGIN_USERNAME,
    component: LoginUsername,
    exact: true,
  },
  {
    path: pathes.SIGNUP_LEGAL_USER,
    component: SignupLegalUser,
    exact: true,
  },
  {
    path: pathes.SIGNUP,
    component: Signup,
    exact: true,
  },

  {
    path: pathes.SIGNUP_FORM,
    component: SignupForm,
    exact: true,
  },
  // {
  //   path: pathes.CHANGE_NUMBER,
  //   component: ChangeNumber,
  //   exact: true,
  // },
  {
    path: pathes.CHANGE_NUMBER_OTP,
    component: ChangeNumberOtp,
    exact: true,
  },
  {
    path: pathes.HOME,
    component: Home,
    exact: true,
  },
  {
    path: pathes.PROFILE,
    component: Profile,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.WALLET,
    component: Wallet,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.WALLET_BARCODE,
    component: WalletBarcode,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.GROUP,
    component: Group,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.MY_GROUPS,
    component: MyGroups,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.CHOOSE_GROUP,
    component: ChooseGroup,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.CREATE_GROUP,
    component: CreateGroup,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.SETTING,
    component: Setting,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.CHANGE_BACKGROUND,
    component: ChangeBackground,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.MY_GIFTS,
    component: MyGifts,
    exact: true,
  },
  {
    path: pathes.QR_PAYMENT,
    component: QrPayment,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.SHOP_PAYMENT,
    component: ShopPayment,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.PAYMENT_CODE,
    component: PaymentCode,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.PAYMENT,
    component: Payment,
    exact: true,
    navButton: true,
    layout: Layout,
  },
  {
    path: pathes.SUCCESS_PAYMENT,
    component: SuccessPayment,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.TRANSACTION_RECEIPT,
    component: TransactionReceipt,
    exact: true,
  },
  {
    path: pathes.CASH_WITH_DRAWAL,
    component: CashWithDrawal,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.USER_LEVELS,
    component: UserLevels,
    exact: true,
    layout: Layout,
  },
  //v-card
  {
    path: pathes.V_CARD,
    component: Vcard,
    exact: true,
    layout: Layout,
  },
  //ticketing
  {
    path: pathes.SUPPORT_TICKET,
    component: SupportTicket,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.USER_MESSAGE,
    component: UserMesage,
    exact: true,
    layout: Layout,
  },

  //referral
  {
    path: pathes.INVITE_FRIENDS,
    component: InviteFriends,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.SHAHRZAD_CODE,
    component: ShahrzadCode,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.FESTIVAL,
    component: Festival,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.CENTERS_PAYMENT,
    component: CentersList,
    exact: true,
    layout: Layout,
  },
  {
    path: pathes.RECEIVE_PAYMENT,
    component: ReceiveMoney,
    exact: true,
    layout: Layout,
  },
]
